import React, { useState } from 'react'

import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import LaunchIcon from '@mui/icons-material/Launch'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { safeHref, openExternal } from '../../utils/safeUrl'

const sourceLabel = (source, index) => {
    const text = (source.source || '').trim()
    if (text.length === 0) return `Source ${index + 1}`
    return text.length > 60 ? `${text.slice(0, 57)}...` : text
}

const ViewSourcesButton = ({ sources, buttonProps = {}, sx, label = 'View Resource', fontSize = 'small' }) => {
    const [anchorEl, setAnchorEl] = useState(null)
    // A source with an unsafe URL never produces a menu item or a button (issue #404).
    const withUrl = (sources || []).filter(s => s && safeHref(s.url))

    if (withUrl.length === 0) return null

    if (withUrl.length === 1) {
        return (
            <Button {...buttonProps} sx={sx} onClick={() => openExternal(withUrl[0].url)}>
                {label}&nbsp;<LaunchIcon fontSize={fontSize} />
            </Button>
        )
    }

    const handleOpen = (event) => setAnchorEl(event.currentTarget)
    const handleClose = () => setAnchorEl(null)
    const handleSelect = (source) => {
        openExternal(source.url)
        handleClose()
    }

    return (
        <>
            <Button
                {...buttonProps}
                sx={sx}
                onClick={handleOpen}
                aria-haspopup="menu"
                aria-expanded={Boolean(anchorEl)}
                endIcon={<ArrowDropDownIcon fontSize={fontSize} />}
            >
                {label}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {withUrl.map((source, index) => (
                    <MenuItem key={source.id ?? index} onClick={() => handleSelect(source)}>
                        {sourceLabel(source, index)}&nbsp;<LaunchIcon fontSize={fontSize} sx={{ ml: 'auto' }} />
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}

export default ViewSourcesButton
